// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3C2rS","left":"StickyBox_left__SAuTN","right":"StickyBox_right__1Cxtq"};